import React, { useEffect, useState } from "react";
// import SideBar from "./components/CusSidebar";
import {
  BrowserRouter as Router,
  createBrowserRouter,
  RouterProvider,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
// import {
//   initializeFirebase,
//   requestFirebaseToken,
// } from "./config/cloudNotification";
// import Layout from "./components/Layout";
import { ToastContainer, toast } from "react-toastify";
// import NotFound from "./pages/NotFound";
// import Dashboard from "./pages/dashboard/Dashboard";
import { routes } from "./config/routes";
import Loading from "./components/Loading";
import { selectCommonData } from "./reducers/common.reducer";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { setCredential, setToken, setRefreshToken, setRememberMe, setUserInfo } from "./reducers/user.reducer";
import { encryptFun, getItemFromStorage, removeItemFromStorage, setItemToStorage } from "./utils/helper";
import { STORAGE_KEYS } from "./config/config";

const router = createBrowserRouter(routes);


function MainContent() {
  // const listenNotification = async () => {
  //   await initializeFirebase();
  //   await requestFirebaseToken();
  // };
  //const location = useLocation();
  const { isLoading } = useSelector(selectCommonData);

  const dispatch = useDispatch();

  const callUserReducer = async () => {
    const token = await getItemFromStorage(STORAGE_KEYS.TOKEN);
    dispatch(setToken({ token: token }));

    const refreshToken = await getItemFromStorage(STORAGE_KEYS.REFRESH_TOKEN);
    dispatch(setRefreshToken({ refreshToken: refreshToken }));

    const userInfo = await getItemFromStorage(STORAGE_KEYS.USER)
    ? JSON.parse(getItemFromStorage(STORAGE_KEYS.USER))
    : getItemFromStorage(STORAGE_KEYS.USER);
    dispatch(setUserInfo({ userInfo: userInfo }));

    const rememberMe = await getItemFromStorage(STORAGE_KEYS.REMEMBER_ME) ? true : true;
    dispatch(setRememberMe({ rememberMe: rememberMe }));

    const credential = await getItemFromStorage(STORAGE_KEYS.CREDENTIAL);
    dispatch(setCredential({ credential: credential }));

    
  }

  useEffect(() => {
    callUserReducer();
  }, []);
  // useEffect(() => {
  //   listenNotification();
  // }, []);
  const notify = () => toast("Wow so easy !");
  return (
    <div className="flex h-screen w-screen bg-gray-100">
      <ToastContainer
        position="bottom-left"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isLoading && <Loading />}
      <RouterProvider router={router} />
    </div>
    );
  }

function App() {

  return (  
      <MainContent />   
  );
}

export default App;